import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup'; // @ts-expect-error module is untyped

import { getAssetPageFeatureI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import AssetPageFeatureUrls from '../../../constants/urls/AssetPageFeature'; // @ts-expect-error module is untyped

import { getUsedPageFeatures } from '../../../selectors/themes';
import { deployed } from '../../../utils/env';
import { getFullPublicUrl } from '../../../utils/urls';
import FilterSideNav from './FilterSideNav';
const getOptionsSelector = createSelector([getUsedPageFeatures], pageFeatures => {
  const options = pageFeatures.map(value => ({
    text: unescapedText(getAssetPageFeatureI18nKey(value)),
    value
  }));
  return options.sort((a, b) => localeComparator(a.text, b.text));
});
const getNavOptionsSelector = createSelector([getOptionsSelector, () => deployed()], (options, isDeployed) => {
  return options.reduce((final, option) => {
    const {
      value
    } = option;
    const url = AssetPageFeatureUrls[value];

    if (url) {
      final.push(Object.assign({}, option, {
        href: `${getFullPublicUrl('en', !isDeployed)}/${url}`
      }));
    }

    return final;
  }, []);
});

function PageFeatureNav({
  value
}) {
  const options = useSelector(getNavOptionsSelector);
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.themes.filters.pageFeatures.title'),
    name: ThemeQueryField.PAGE_FEATURES,
    options: options,
    value: activeValue
  });
}

const PageFeatureFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const isPrerender = getIsPrerenderUserAgent();
  const options = useSelector(getOptionsSelector);
  return isPrerender ? /*#__PURE__*/_jsx(PageFeatureNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    disabled: disabled,
    multi: true,
    name: ThemeQueryField.PAGE_FEATURES,
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
};

export default PageFeatureFilter;